<template>
    <the-section class="team" legend="Members" id="tribe">
        <team-member
            v-for="(member, index) in team"
            :key="member.id"
            :reverse="index % 2 !== 0"
            :person="member"
        />
    </the-section>
</template>

<script>
import TeamMember from "@/components/TeamMember";
import TheSection from "@/components/TheSection";
import shuffle from "lodash/shuffle";

export default {
    components: {
        TeamMember,
        TheSection
    },
    computed: {
        team() {
            return shuffle(this.$store.state.team);
        }
    }
};
</script>

<style scoped lang="sass">
.team
    display: flex
    flex-direction: column
    gap: calc(var(--line-base) * 4)
    padding-top: calc(var(--line-base) * 4)
    padding-bottom: calc(var(--line-base) * 9)

.legend
    opacity: .67
    color: #FFF
</style>
